/**
 * Progressive enhancement for collection sorting.
 *
 * The form works without this file: pick a sort option, press Apply. This only
 * removes that second step. The button is hidden from here rather than in CSS
 * so it stays available when JavaScript fails to load.
 */
(function () {
  'use strict';

  var select = document.querySelector('[data-sort-select]');
  var submit = document.querySelector('[data-sort-submit]');
  if (!select || !submit) return;

  var form = select.form;
  if (!form) return;

  submit.hidden = true;

  select.addEventListener('change', function () {
    form.submit();
  });
})();
